import Category from './Category';

const Export = {
  Category,
};

export default Export;
